export default __webpack_public_path__ + "static/media/Caro3.aa21d2b7.jpg";